/**
*   Тут функции для работы с библиотечкой vue-select
**/
import debounce from 'lodash/debounce';

import ajaxRequest from '@/utils/request';

/**
*   Возвращает значение объекта obj по названию names
*
*   :param: obj – Object, объект, значение атрибута которого хотелось бы получить;
*   :param: names – Union[Array, String], название атрибута (путь).
*
*   Пример:
*   let obj = {a: {b: c: 1234}}
*   getDeepAttr(obj, 'a.b.c') === getDeepAttr(obj, ['a', 'b', 'c']) === 1234
*
**/
function getDeepAttr(obj, names) {
    if (typeof names === 'string') names = names.split('.');
    const name = names.shift();
    if (names.length === 0) return obj[name];
    return getDeepAttr(obj[name], names);
}

/**
*   Возвращает функцию, вызывающую сервис поиска данных по введенной строке ``search``
*
*   :param url: адрес сервеса,
*   :param varName: имя переменной из data, в которую положим результат поиска
**/

const getData = debounce(({ search, loading, componentInstance, url, varName, filters }) => {
    const params = { q: search };
    if (filters) {
        filters.forEach(item => {
            let name, value;
            if (typeof item === 'string') {
                name = item.split('.').pop();
                value = item;
                params[ name ] = JSON.stringify(getDeepAttr(componentInstance, value));
            } else if (typeof item === 'object') {
                params[ item.name ] = item.value;
            } else {
                throw new Error(`Invalid type for filter ${item} – ${typeof item}`);
            }
        });
    }

    ajaxRequest({
        url,
        params,
        success: (response) => {
            componentInstance[ varName ] = response.data;
            loading(false);
        }
    });
}, 250);

export const getAjaxSearchMethod = (url, varName = 'itemsChoice', filters) => {
    return function(search, loading) {
        loading(true);

        getData({
            search,
            loading,
            componentInstance: this,
            url: url || this.searchPath,
            varName,
            filters: filters || this.filters
        });
    };
};



// WEBPACK FOOTER //
// ./src/utils/vSelect.js